import { TLicensePlateSupportedCountryCodes } from './types';
import validationByTenant from './validationByCountryCode';
import isValid from './isValid';

type TLicensePlateValidation = {
  isValid(licensePlate: string): boolean;
};

export default (countryCode: TLicensePlateSupportedCountryCodes): TLicensePlateValidation => {
  const validation = validationByTenant[countryCode];

  return {
    isValid: (licensePlate: string) => isValid(licensePlate, validation),
  };
};
